export const TEMPORARY_SUBMIT_BUTTON_DISABLED_SOLUTION_SELECTOR = "temporary-submit-button-disabled-solution";

export const APPOINTMENT_NEED_TO_SCHEDULE = "NEED_TO_SCHEDULE";
